import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[testId]',
})
export class TestIdDirective implements OnInit {
  @Input('testId') testId!: string;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    if (this.testId) {
      this.renderer.setAttribute(this.el.nativeElement, 'data-testid', this.testId);
    }
  }
}
